<template>
  <div class="page-wrapper">
    <!-- Modern Header -->
    <header class="header">
      <div class="header-container">
        <router-link to="/" class="logo-link">
          <img src="@/assets/logo.png" alt="Nexthome4U Logo" class="logo" />
        </router-link>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <div class="success-card">
        <div class="success-animation">
          <div class="checkmark-circle">
            <svg class="checkmark" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22,4 12,14.01 9,11.01"></polyline>
            </svg>
          </div>
        </div>
        
        <div class="card-content">
          <h1 class="title">Password Reset Successful!</h1>
          <p class="subtitle">Your password has been successfully updated. You can now sign in with your new password.</p>
        </div>

        <div class="actions">
          <button class="login-button" @click="goToLogin">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10,17 15,12 10,7"></polyline>
              <line x1="15" y1="12" x2="3" y2="12"></line>
            </svg>
            Continue to Sign In
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

export default {
    name: 'PasswordResetSuccess',
    methods: {
        goToLogin() {
            this.$router.push('/login');
        }
    }
}
</script>

<style scoped>

* {
  box-sizing: border-box;
}

.page-wrapper {
  min-height: 100vh;
  background: #fcfbfb;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
}

/* Header */
.header {
  position: sticky;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 1rem 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.logo-link {
  display: inline-block;
  transition: transform 0.2s ease;
}

.logo-link:hover {
  transform: scale(1.05);
}

.logo {
  height: 40px;
  width: auto;
  max-width: 150px;
}

/* Main Content */
.main-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  min-height: calc(100vh - 80px);
}

.success-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 32px 64px rgba(0, 0, 0, 0.12),
    0 0 0 1px rgba(255, 255, 255, 0.05);
  padding: 3rem;
  width: 100%;
  max-width: 420px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.success-animation {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
}

.checkmark-circle {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 8px 32px rgba(16, 185, 129, 0.3);
}

.checkmark {
  color: white;
  animation: drawCheckmark 0.8s ease-in-out 0.3s both;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes drawCheckmark {
  0% {
    stroke-dasharray: 0 100;
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dasharray: 100 0;
    stroke-dashoffset: 0;
  }
}

.card-content {
  margin-bottom: 2.5rem;
}

.title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.subtitle {
  color: #6b7280;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

.actions {
  animation: fadeInUp 0.6s ease-out 0.6s both;
}

.login-button {
  background: linear-gradient(135deg, #5b2e8e 0%, #7c3aed 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  min-height: 48px;
  box-shadow: 0 4px 12px rgba(91, 46, 142, 0.4);
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(91, 46, 142, 0.4);
}

.login-button:active {
  transform: translateY(0);
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 640px) {
  .main-content {
    padding: 1rem;
    align-items: flex-start;
    padding-top: 2rem;
  }

  .success-card {
    padding: 2rem 1.5rem;
    border-radius: 16px;
    margin-top: 1rem;
  }

  .title {
    font-size: 1.75rem;
  }

  .checkmark-circle {
    width: 100px;
    height: 100px;
  }

  .checkmark {
    width: 48px;
    height: 48px;
  }
}

@media (max-width: 480px) {
  .success-card {
    padding: 1.5rem 1rem;
  }

  .title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 0.925rem;
  }

  .checkmark-circle {
    width: 80px;
    height: 80px;
  }

  .checkmark {
    width: 40px;
    height: 40px;
  }
}
</style>